import {
    FETCH_USER_LISTINGS_CONTENT,
    FETCH_USER_LISTINGS_CONTENT_SUCCESS,
    FETCH_USER_LISTINGS_CONTENT_FAILED,
    USER_LISTINGS_DELETE__MESSAGE,
    USER_LISTINGS_DELETE_MESSAGE_SUCCESS,
    USER_LISTINGS_DELETE__MESSAGE_FAILED
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false,
};

export default function (state = initialState, { type, payload }) {

    switch (type) {
        case FETCH_USER_LISTINGS_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_USER_LISTINGS_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_USER_LISTINGS_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case USER_LISTINGS_DELETE__MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case USER_LISTINGS_DELETE_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case USER_LISTINGS_DELETE__MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };
        default:
            return state;
    }
}
